module.exports = __webpack_public_path__ + "static/media/24-1.adf97bae.mp3";